export default __webpack_public_path__ + "static/media/home-digital-agency-img-09.72705e73.jpg";